import { render, staticRenderFns } from "./notice_article.vue?vue&type=template&id=67fe7052&scoped=true"
import script from "./notice_article.vue?vue&type=script&lang=js"
export * from "./notice_article.vue?vue&type=script&lang=js"
import style0 from "./notice_article.vue?vue&type=style&index=0&id=67fe7052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe7052",
  null
  
)

export default component.exports